
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppComponent } from '../app.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
})
export class UsersComponent {
  currentUser: any;
  users: any;
  usersList: any;
  addModal = false;
  spinner: boolean = false;
  roles: any;
  payplans: any;
  groups: any;
  canSee: boolean = false;
  userForm: FormGroup;
  radioValue = 'active';
  all_templates: any;
  companies: any = [];
  providers: any = [];
  selectedCompany: any;
  fidiumExternals: any = [];
  searchTerm = '';

  constructor(
    private dataService: DataserviceService,
    private modal: NzModalService,
    private app: AppComponent,
    private nzNotify: NzNotificationService,
    private router: Router
  ) {
    this.userForm = new FormGroup({
      id: new FormControl(null),
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      phone: new FormControl(null, [Validators.required]),
      role: new FormControl(null, [Validators.required]),
      groups: new FormControl(null),
      groupsVisiblity: new FormControl(null),
      territory: new FormControl(null),
      documents: new FormControl(null),
      providers: new FormControl([]),
      payplans: new FormControl([]),
      company: new FormControl(null, [Validators.required]),
      pins: new FormControl(false),
      areas: new FormControl(false),
      status: new FormControl('active'),
      providerExternals: new FormArray([]),
      fidiumExternal: new FormControl(null)
    });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);

    this.selectedCompany = this.currentUser?.company_id;
    this.spinner = true;
    this.getUsers();
  }

  getCompanies() {
    this.canSee = true
    this.dataService.getData('company')
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
          this.getAssociatedCompanyInfo();
        },
        error: (err: any) => {
          console.log('error on get all companies: ', err)
          this.errorNotification('Failed to get all companies')
        }
      })
  }

  getDistributorCompanies() {
    this.canSee = true;
    this.dataService.getData(`company/companies-by-distributor/${this.currentUser?.distributor_id}`)
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
          this.getAssociatedCompanyInfo();
        },
        error: (err: any) => {
          console.log('error on get companies by distributor: ', err)
          this.errorNotification('Failed to get companies by distributor')
        }
      });
  }

  getAssociatedCompanyInfo() {
    if (this.userForm.get('company')?.value) {
      this.dataService.getData(`company/associated-company-info/${this.userForm.get('company')?.value}/${false}`)
        .subscribe({
          next: (res: any) => {

            this.groups = res?.data?.groups;
            this.providers = res?.data?.providers;
            this.payplans = res?.data?.payplans;

            if (this.canSee) {
              this.roles = res?.data?.roles;
            } else {
              this.roles = res?.data?.roles.filter((role: any) => role.name.toLowerCase() !== 'admin');
            }

            // this.getCompanyDocs();
          },
          error: (err: any) => {
            console.log('error on getUsersByCompanyId: ', err)
            this.errorNotification('Failed to get users by selected company')
          }
        });
    }
  }


  hasPermission(permission: string): boolean {
    return this.app.hasPermission(permission);
  }

  setParams() {
    let params = new HttpParams()

    if (this.hasPermission('view_all_users')) {
      params = params.set('all', true);
    }
    else if (this.hasPermission('view_distributor_users')) {
      params = params.set('distributor_id', this.currentUser.distributor_id);
    }
    else if (this.hasPermission('view_company_users')) {
      params = params.set('company_id', this.currentUser.company_id);
    }
    else if (this.currentUser?.viewable_groups?.length > 0) {
      params = params.set('viewable_groups', this.currentUser.viewable_groups);
    }
    else {
      params = params.set('my_id', this.currentUser.id);
    }

    return params;
  }

  getUsers() {
    let params = this.setParams();

    this.dataService.getData(`users/users-list`, { params })
      .subscribe({
        next: (res: any) => {
          this.users = res;
          this.filterUsers();
          this.spinner = false;
        }
      })
  }

  addChip() {
    if (this.userForm.get('fidiumExternal')?.value && !this.fidiumExternals.includes(this.userForm.get('fidiumExternal')?.value)) {
      this.fidiumExternals.push(this.userForm.get('fidiumExternal')?.value);
      this.userForm.get('fidiumExternal')?.setValue(null);
    }
  }

  removeChip(chip: any) {
    this.fidiumExternals = this.fidiumExternals.filter((c: any) => c !== chip);
  }

  showModal(u: any) {
    this.router.navigate(['users', 'user-profile'], {
      queryParams: { user: u.user_id }
    });
  }

  addUser() {
    this.addModal = true;
    this.userForm.get('company')?.setValue(this.currentUser.company_id)
    if (this.hasPermission('view_all_users')) {
      this.getCompanies();
    } else if (this.hasPermission('view_distributor_users')) {
      this.getDistributorCompanies();
    } else {
      this.getAssociatedCompanyInfo()
    }
  }

  confirmModal() {
    if (this.userForm.valid) {
      this.createUser();
    } else {
      this.nzNotify.create(
        'warning',
        'Warning!',
        `Please fill out the required fields and make sure they are formatted correctly`,
        { nzPlacement: 'top' }
      );
    }
  }

  cancelModal() {
    this.addModal = false;
    this.fidiumExternals = [];
    this.userForm.reset();
  }

  createUser() {
    this.spinner = true;

    let formatted = this.providerExternals.value.reduce((acc: any, item: any) => {
      if (item.key && item.value != null) {
        acc[item.key] = item.value
      }
      return acc;
    }, {})

    let comp = this.companies.find((c: any) => c.id == this.userForm.get('company')?.value)

    let obj = {
      first_name: this.userForm.get('firstName')?.value,
      last_name: this.userForm.get('lastName')?.value,
      email: this.userForm.get('email')?.value,
      phone: this.userForm.get('phone')?.value ? this.userForm.get('phone')?.value.replace(/\D/g, '') : '',
      role: this.userForm.get('role')?.value,
      pins: this.userForm.get('pins')?.value || false,
      areas: this.userForm.get('areas')?.value || false,
      payplans: this.userForm.get('payplans')?.value || [],
      company_id: this.canSee ? this.userForm.get('company')?.value : this.currentUser.company_id,
      distributor_id: this.canSee ? comp.distributor_id : this.currentUser.distributor_id,
      viewable_groups: this.userForm.get('groupsVisiblity')?.value,
      documents: this.userForm.get('documents')?.value,
      providers: this.userForm.get('providers')?.value || [],
      provider_external_ids: formatted || {},
      external_ids: this.fidiumExternals
    };

    this.dataService.postData(obj, 'users/create')
      .subscribe({
        next: (res: any) => {
          if (res?.data?.used) {
            this.spinner = false;
            this.errorNotification(res?.data?.message);
          } else if (res && res?.result !== "success") {
            this.errorNotification(res.message)
            this.spinner = false;
          } else {
            this.getUsers();
            this.addModal = false;
            this.fidiumExternals = [];
            this.userForm.reset();
            this.successNotification('created');
          }
        },
        error: (error) => {
          this.errorNotification('Failed to create user!');
          this.spinner = false;
        },
      });
  }

  search(event: any) {
    this.searchTerm = event.target.value || '';
    this.filterUsers();
  }

  onTabChange(index: number) {
    this.radioValue = index === 0 ? 'active' : 'inactive';
    this.filterUsers();
  }

  filterUsers() {
    if (!this.users) {
      this.usersList = [];
      return;
    }

    const term = this.searchTerm.toLowerCase();

    this.usersList = this.users.filter((item: any) => {
      const name = `${item.first_name} ${item.last_name}` || '';
      const email = item.email || '';
      const phoneNumber = item.phone || '';
      const id = String(item.user_id) || '';

      const matchesSearch =
        !term ||
        name.toLowerCase().includes(term) ||
        email.toLowerCase().includes(term) ||
        phoneNumber.toLowerCase().includes(term) ||
        id.includes(term);

      return matchesSearch && item.status === this.radioValue;
    });
  }

  async impersonateUser(user: any) {
    try {
      const result = await this.dataService.postData(user, 'users/impersonate').toPromise();

      if (result?.data?.user && result?.data?.token) {
        if (result?.message === 'Impersonation successful') {
          localStorage.setItem('originalUser', localStorage.getItem('user')!);
          localStorage.setItem('originalToken', localStorage.getItem('access_token')!);

          localStorage.setItem('user', JSON.stringify(result.data.user));
          localStorage.setItem('access_token', result.data.token);
          localStorage.setItem('isImpersonating', 'true');

          window.location.href = '/portals';
        }
      } else {
        this.errorNotification('Failed to retrieve user or token from response');
      }
    } catch (error) {
      this.errorNotification('Failed to impersonate user');
      console.error('Impersonation error:', error);
    }
  }

  phoneNumberDisplay(phone: string) {
    if (!phone) {
      return ''
    }
    const digits = phone.toString().replace(/\D/g, '');
    const cleanNumber = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    return cleanNumber.length == 10 ? cleanNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3') : phone.toString();
  }


  successNotification(str: string) {
    this.nzNotify.create(
      'success',
      'Success!',
      `User was ${str} successfully!`,
      { nzPlacement: 'top' }
    );
  }


  errorNotification(str: string) {
    this.nzNotify.create(
      'error',
      'Error!',
      str,
      { nzPlacement: 'top' }
    );
  }

  get providerExternals(): FormArray {
    return this.userForm.get('providerExternals') as FormArray;
  }

  addProviderExternal() {
    this.providerExternals.push(
      new FormGroup({
        key: new FormControl(null),
        value: new FormControl(null)
      })
    );
  }

  removeProviderExternal(index: number) {
    this.providerExternals.removeAt(index);
  }

  sort() {
    return this.providers.sort((a: any, b: any) => {
      return a.name.localeCompare(b.name);
    });
  }
}
